import React from 'react';
import {
  Button,
  DatePicker,
  Drawer,
  Table,
  Col,
  Form,
  Select,
  Row,
  Typography,
} from 'antd';
import './questionnaire.css';
import reqwest from './apiRequest';
import moment from 'moment';

const { RangePicker } = DatePicker;
const { Title } = Typography;
const { Option } = Select;

class App extends React.Component {
  constructor(props) {
    super(props);

    this.columns = [
      {
        title: 'Submitted',
        dataIndex: 'created_time',
        key: 'created_time',
        render: (created_time) => moment(created_time).format('DD/MM/YY HH:mm'),
      },
      {
        title: 'Mom Name',
        dataIndex: 'mom_name',
        key: 'mom_name',
      },
      {
        title: 'Child Gender',
        dataIndex: 'child_gender',
        key: 'child_gender',
        render: (gender) => (gender === 'M' ? 'Boy' : 'Girl'),
      },
      {
        title: 'Child DOB',
        dataIndex: 'child_data_of_birth',
        key: 'child_data_of_birth',
        render: (dob) => moment(dob).format('DD/MM/YY'),
      },
      {
        title: 'Phone Number',
        dataIndex: 'phone_number',
        key: 'phone_number',
      },
      {
        title: 'Country',
        dataIndex: 'country',
        key: 'country',
      },
      {
        title: 'Feeding Type',
        dataIndex: 'feeding_type',
        key: 'feeding_type',
      },
      {
        title: 'Formula Using',
        dataIndex: 'formula_using',
        key: 'formula_using',
      },
      {
        title: 'Result',
        dataIndex: 'result_status',
        key: 'result_status',
      },
      {
        title: 'Scores',
        dataIndex: 'dapm_final_score',
        key: 'dapm_final_score',
      },
      {
        title: 'Details',
        dataIndex: 'id',
        key: 'details',
        render: (id, record) =>
          record.selected_answer_id ? (
            <Button type="link" onClick={() => this.onDrawer(true, id)}>
              View
            </Button>
          ) : (
            <></>
          ),
      },
    ];

    this.state = {
      data: [],
      drawer: {},
      search: {
        filter_date: null,
        age_group: null,
        result: null,
      },
      placeholder: ['Start Date', 'End Date'],
      pagination: {},
      loading: false,
      visible: false,
    };
  }

  componentDidMount() {
    document.title = 'Questionnaire';
    this.fetch();
  }

  // fetch = async () => {
  //   this.setState({ loading: true });
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_API_URL}/iron_question`,
  //       {
  //         method: 'GET',
  //       },
  //     );
  //     const data = await response.json();
  //     this.setState({
  //       data: data.results,
  //       loading: false,
  //     });
  //   } catch (error) {
  //     this.setState({ loading: false });
  //     console.error('Error fetching data:', error);
  //   }
  // };

  fetch = (params = {}) => {
    console.log({
      age_group_id: this.state.search.age_group_id,
      results: this.state.search.result,
      date_range: this.state.search.date_range,
      ...params,
    });
    this.props.pageLoading(true);

    reqwest({
      url: process.env.REACT_APP_API_URL + '/iron_question',
      method: 'get',
      data: {
        age_group_id: this.state.search.age_group,
        results: this.state.search.result,
        date_range: this.state.search.filter_date,
        ...params,
      },
      type: 'json',
    }).then((data) => {
      this.setState({
        data: data.results,
      });

      this.props.pageLoading(false);

      document.body.style.overflow = null;
    });
  };

  onDrawer = async (bl, id = null) => {
    this.setState({ visible: bl });

    if (id === null) {
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/iron_question/view/${id}`,
      );
      const data = await response.json();
      this.setState({
        drawer: data,
        loading: false,
      });
    } catch (error) {
      this.setState({ loading: false });
      console.error('Error fetching data:', error);
    }
  };

  filterData = async () => {
    const { search } = this.state;
    const { filter_date, result, age_group } = search;

    const body = {
      age_group_id: age_group || null,
      results: result || null,
      range_date: filter_date || null,
    };

    this.setState({ loading: true });
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/iron_question`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        },
      );
      const data = await response.json();
      this.setState({
        data: data.results,
        loading: false,
      });
    } catch (error) {
      this.setState({ loading: false });
      console.error('Error fetching data:', error);
    }
  };

  handleFormChange = (changedValues) => {
    const { search } = this.state;

    this.setState(
      {
        search: {
          ...search,
          ...changedValues,
        },
      },
      () => {
        this.fetch();
      },
    );

    // if (changedValues.filter_date) {
    //   const [start, end] = changedValues.filter_date;

    //   this.setState({
    //     placeholder:
    //       start && end
    //         ? [start.format('DD/MM/YYYY'), end.format('DD/MM/YYYY')]
    //         : ['Start Date', 'End Date'],
    //   });
    // }
  };

  handleDateRangeFilterChange = (value) => {
    if (value.length > 0) {
      const [start, end] = value;
      console.log({ start, end });
      var date = [start.format('DD/MM/YYYY'), end.format('DD/MM/YYYY')];
      console.log({ date });
      this.handleFormChange({ filter_date: date });

      this.setState({
        placeholder: [start.format('DD/MM/YYYY'), end.format('DD/MM/YYYY')],
      });
    } else {
      this.handleFormChange({ filter_date: '' });

      this.setState({
        placeholder: ['Start Date', 'End Date'],
      });
    }
  };

  exportExcel = async () => {
    const { search } = this.state;

    const body = {
      age_group_id: search.age_group || null,
      results: search.result || null,
      date_range: search.filter_date || null,
    };

    this.setState({ loading: true });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/iron_question/export`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        },
      );

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'results.xlsx';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } else {
        console.error('Failed to download file');
      }

      this.setState({ loading: false });
    } catch (error) {
      this.setState({ loading: false });
      console.error('Error fetching data:', error);
    }
  };

  resetFilter = () => {
    this.props.form.resetFields();
    this.setState(
      {
        search: {
          filter_date: null,
          age_group: null,
          result: null,
        },
        placeholder: ['Start Date', 'End Date'],
      },
      () => {
        this.fetch();
      },
    );
  };

  render() {
    const { visible, drawer, search, placeholder, data, pagination, loading } =
      this.state;
    const { getFieldDecorator } = this.props.form;

    return (
      <div id="questionnaire-component">
        <Drawer
          id="question-component-drawer"
          title="Questionnaire"
          placement="right"
          closable={true}
          width={730}
          onClose={() => this.onDrawer(false)}
          destroyOnClose
          visible={visible}
        >
          <Row>
            <Col span={24}>
              <Title level={3}>{drawer.question_group}</Title>
            </Col>
          </Row>
          {drawer.questions &&
            drawer.questions.map((qa, index) => (
              <div key={qa.id}>
                <Row>
                  <Col span={1}>
                    <strong>{index + 1}</strong>
                  </Col>
                  <Col span={3}>
                    <p>
                      <strong>question : </strong>
                    </p>
                  </Col>
                  <Col span={20}>{qa.question_en}</Col>
                </Row>
                <Row>
                  <Col span={1}></Col>
                  <Col span={3}>
                    <p>
                      <strong>answer : </strong>
                    </p>
                  </Col>
                  <Col span={20}>{qa.selectedAnswer?.answer_en}</Col>
                </Row>
                <div
                  style={{
                    border: 'none',
                    borderTop: '1px solid #EDEDED',
                    marginBottom: '10px',
                  }}
                />
              </div>
            ))}
        </Drawer>

        <Row>
          <Col span={24}>
            <Title level={1}>Questionnaire</Title>
          </Col>
        </Row>

        <div className="questionnaire-container">
          <Row gutter={[16, 16]}>
            <Col span={6}>
              <Form.Item>
                {getFieldDecorator('filter_date', {
                  initialValue: search.filter_date,
                })(
                  <RangePicker
                    format={'DD/MM/YYYY'}
                    placeholder={placeholder}
                    style={{ width: '100%' }}
                    onChange={(dates) =>
                      this.handleDateRangeFilterChange(dates)
                    }
                  />,
                )}
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item>
                {getFieldDecorator('result', {
                  initialValue: search.result,
                })(
                  <Select
                    placeholder="Result"
                    style={{ width: '100%' }}
                    onChange={(value) =>
                      this.handleFormChange({ result: value })
                    }
                  >
                    <Option value="low">Low Risk</Option>
                    <Option value="high">High Risk</Option>
                  </Select>,
                )}
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item>
                {getFieldDecorator('age_group', {
                  initialValue: search.age_group,
                })(
                  <Select
                    placeholder="Age Group"
                    style={{ width: '100%' }}
                    onChange={(value) =>
                      this.handleFormChange({ age_group: value })
                    }
                  >
                    <Option value="1">6 months - 1 year old</Option>
                    <Option value="2">1 – 3 years old</Option>
                    <Option value="3">4 - 6 years old</Option>
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col span={3}>
              <Button onClick={this.resetFilter}>Reset</Button>
            </Col>
            <Col span={3}>
              <Button
                type="primary"
                style={{ width: '100%' }}
                onClick={this.exportExcel}
              >
                Export
              </Button>
            </Col>
          </Row>
          <Table
            columns={this.columns}
            dataSource={data}
            pagination={pagination}
            loading={loading}
            onChange={this.handleTableChange}
          />
        </div>
      </div>
    );
  }
}

export default Form.create({ name: 'questionnaire' })(App);
